import { assert } from '@sindresorhus/is';
import { useContext } from 'react';
import { useStore } from 'zustand';

import { CompanyOnboardingContext } from './CompanyOnboardingContext';

import type { CompanyOnboardingStoreWithComputedStore } from './company-onboarding-store';

export const useCompanyOnboardingStore = <T>(selector: (state: CompanyOnboardingStoreWithComputedStore) => T): T => {
    const signupStoreContext = useContext(CompanyOnboardingContext);

    assert.plainObject(signupStoreContext);

    return useStore(signupStoreContext, selector);
};
